import React from 'react';
import { RootStore } from '../stores';
import { RootStoreContext } from './../stores/RootStoreContext';

export const useRootStore = (): RootStore => {
    const store = React.useContext(RootStoreContext);
    if (!store) {
        throw new Error('useRootStore must be used within a RootStoreProvider.');
    }
    return store;
};
